import React from "react";
import Spinner from "./Spinner";

export default function FullScreenSpinner({ label = "Loading..." }) {
  return (
    <div className="fixed inset-0 z-[9999] bg-white/70 dark:bg-gray-900/70 backdrop-blur-sm flex items-center justify-center">
      <Spinner size={56} label={label} />
    </div>
  );
}
